// extracted by mini-css-extract-plugin
export default {"social__wrapper":"Social_social__wrapper__qym6N","social__links":"Social_social__links__xaQjT","discord":"Social_discord__r4Y-a","telegram":"Social_telegram__MJ6KM"};